import {} from "../BluxClient";
import {
  Bridge,
  BridgeAction,
  BridgePayload,
  BridgePayloadMap,
} from "./Bridge";
import { Logger } from "../utils/Logger";

export class RNBridge extends Bridge {
  readonly platform = "react-native";

  protected postMessage(action: BridgeAction, payload?: BridgePayload) {
    if (typeof window === "undefined") {
      Logger.error("window is undefined", {
        tags: { from: "RNBridge.postMessage" },
      });

      return;
    }

    if (!window.ReactNativeWebView?.postMessage) {
      Logger.error("No React Native WebView available", {
        tags: { from: "RNBridge.postMessage" },
      });
      return;
    }

    window.ReactNativeWebView.postMessage(JSON.stringify({ action, payload }));
  }

  initialize(payload: BridgePayloadMap["initialize"]) {
    this.postMessage("initialize", payload);
  }

  signIn(payload: BridgePayloadMap["signIn"]) {
    this.postMessage("signIn", payload);
  }

  signOut() {
    this.postMessage("signOut");
  }

  setUserProperties(payload: BridgePayloadMap["setUserProperties"]) {
    this.postMessage("setUserProperties", payload);
  }

  setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ) {
    this.postMessage("setCustomUserProperties", payload);
  }

  sendEvent(payload: BridgePayloadMap["sendEvent"]) {
    this.postMessage("sendEvent", payload);
  }
}
